module.exports = new __parcel__URL__("settings_text.5d108d90.png").toString();